export default __webpack_public_path__ + "static/media/chevron-Icon.d24594c4.svg";